import { render, staticRenderFns } from "./DesignarCurso.vue?vue&type=template&id=5daeb90f&scoped=true&"
import script from "./DesignarCurso.vue?vue&type=script&lang=js&"
export * from "./DesignarCurso.vue?vue&type=script&lang=js&"
import style0 from "./DesignarCurso.vue?vue&type=style&index=0&id=5daeb90f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daeb90f",
  null
  
)

export default component.exports